import { datadogLogs } from '@datadog/browser-logs';

// import: styles
// import: assets
// import: constants
import { datadogRum } from '@datadog/browser-rum';
import posthog from 'posthog-js';
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// import: utils
import { getCurrentUser } from 'core/utils/firebaseUtil';

// import: redux
// import: components
import LoadingScreen from 'core/navigation/loading-screen/LoadingScreen';
import { LOGIN } from 'core/navigation/Routes';
import { useSelector } from 'react-redux';
import { userProfileSelector } from 'core/store/reducers/appReducer/AppSlice';

// import: lazy load components

function RequireAuth() {
	const [checkingUserLoadStatus, setCheckingUserLoadStatus] = useState(true);
	const [firebaseTokenExists, setFirebaseTokenExists] = useState(false);
	const userProfile = useSelector(userProfileSelector);

	useEffect(() => {
		(async () => {
			await getCurrentUser()
				.then((user) => {
					if (user) {
						if (user.isAnonymous) {
							throw new Error('User is anonymous');
						}
						// NOTE posthog.identify
						posthog.identify(user.email, {
							userPropertiesToSetOnce: {
								createdAt: userProfile?.createdAt,
							},
						});
						datadogRum.setUser({
							email: user.email,
						}); // Set Datadog RUM User ID
						datadogLogs.setUser({
							email: user.email,
						}); // Set Datadog Logs User ID

						setFirebaseTokenExists(true);
						setCheckingUserLoadStatus(false);
					}
				})
				.catch(() => {
					setCheckingUserLoadStatus(false);
					setFirebaseTokenExists(false);
				});
		})();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (checkingUserLoadStatus) {
		return <LoadingScreen />;
	}
	if (!firebaseTokenExists) {
		return <Navigate to={`/${LOGIN}`} replace />;
	}

	return <Outlet />;
}

export default RequireAuth;
